import restApiDispatcher from "@/store/utils/api-dispatcher";
import { Misc } from "@/models";
import { rest } from "lodash";

const getAboutUs = (context, params) => {
  restApiDispatcher(context, {
    resource: Misc,
    action: "getAboutUs",
    loadingKey: "aboutUsLoading",
    storeKey: "aboutUs",
    commitType: "show",
    params
  });
};

const getFaq = (context, params) => {
  restApiDispatcher(context, {
    resource: Misc,
    action: "getFaq",
    loadingKey: "faqLoading",
    storeKey: "faq",
    commitType: "indexUnwrapped",
    params
  });
};

const getContactUs = (context, params) => {
  restApiDispatcher(context, {
    resource: Misc,
    action: "getContactUs",
    loadingKey: "contactUsLoading",
    storeKey: "contactUs",
    commitType: "show",
    params
  });
};

const sendMail = (context, params) => {
  restApiDispatcher(context, {
    resource: Misc,
    action: "sendMail",
    loadingKey: "submitContactFormLoading",
    storeKey: "contactForm",
    message: "Message Sent",
    params
  });
};

const getResourceByType = (context, params) => {
  restApiDispatcher(context, {
    resource: Misc,
    action: "getResourceByType",
    loadingKey: `${params.storeKey}Loading`,
    storeKey: `${params.storeKey}`,
    silent: true,
    commitType: `${params.commitType}`,
    params
  });
};

const getPricing = (context, params) => {
  restApiDispatcher(context, {
    resource: Misc,
    action: "getPricing",
    loadingKey: "PricingLoading",
    storeKey: "pricing",
    commitType: "show",
    params
  });
};

const getAthletePricing = (context, params) => {
  restApiDispatcher(context, {
    resource: Misc,
    action: "getAthletePricing",
    loadingKey: "pricingByTypeLoading",
    storeKey: "athletepricing",
    commitType: "show",
    params
  });
};

const getpremiumclubHeadCoachPricing = (context, params) => {
  restApiDispatcher(context, {
    resource: Misc,
    action: "getpremiumclubHeadCoachPricing",
    loadingKey: "premiumclubHeadCoachPricingLoading",
    storeKey: "premiumclubHeadCoachPricing",
    commitType: "show",
    params
  });
};

const getPricingDetail = (context, params) => {
  restApiDispatcher(context, {
    resource: Misc,
    action: "getPricingDetail",
    storeKey: "pricingDetail",
    loadingKey: "pricingDetailLoading",
    commitType: "show",
    silent: true,
    params
  });
};

const getPricingPictures = (context, params) => {
  restApiDispatcher(context, {
    resource: Misc,
    action: "getPricingPictures",
    storeKey: "pricingDetaiPictures",
    loadingKey: "pricingDetailPicturesLoading",
    silent: true,
    params
  });
};

const getPrivacyPolicy = context => {
  restApiDispatcher(context, {
    resource: Misc,
    action: "getPrivacyPolicy",
    storeKey: "privacyPolicy",
    loadingKey: "privacyPolicyLoading",
    silent: true,
    commitType: "show"
  });
};

const getTermsAndConditions = context => {
  restApiDispatcher(context, {
    resource: Misc,
    action: "getTermsAndConditions",
    storeKey: "termsAndConditions",
    loadingKey: "termsAndConditionsLoading",
    silent: true,
    commitType: "show"
  });
};

export default {
  getAboutUs,
  getFaq,
  getContactUs,
  sendMail,
  getResourceByType,
  getPricing,
  getAthletePricing,
  getpremiumclubHeadCoachPricing,
  getPricingDetail,
  getPricingPictures,
  getPrivacyPolicy,
  getTermsAndConditions
};
